export const BASE_API_URL = `${process.env.VUE_APP_BASE_API_URL}/`;
